<div [hidden]="!isLoading" class="page-loader text-center">
    <div class="loader"></div>
</div>

@if (pages$ | async) {
    <div class="row">
        <div class="col-sm-12 search-results-content px-0">
            <core-client-search-form [autoFocus]="!hasSearchTerm()"></core-client-search-form>

            <div class="row search-top">
                @if ((!hasResults() && hasSearchTerm()) || (hasResults() && introText)) {
                    <div class="col-sm-12">
                        @if (!hasResults() && hasSearchTerm() && search.isActive() && !isLoading) {
                            <p [innerHTML]="noResultsText"></p>
                        }
                        @if (hasResults() && introText) {
                            <p [innerHTML]="introText"></p>
                        }
                    </div>
                }
            </div>

            <div class="search-results__tabs">
                @if ((faq$ | async)?.resource; as faq) {
                    <h2>{{ 'Top FAQ' | translate }}</h2>
                    <p></p>
                    <core-block-ai-faq [faq]="faq"></core-block-ai-faq>
                }

                @if (hasResults()) {
                    <div
                        class="d-flex w-100 align-items-center justify-content-between mt-4-5 mb-4 flex-column flex-sm-row">
                        <h2 class="mt-0 mb-0 text-start w-100">
                            {{ ((faq$ | async)?.resource ? 'Other Results' : 'Results') | translate }}
                        </h2>
                        @if (!isLoading) {
                            @if (!isListFormat) {
                                <p class="w-100 text-end mb-0">
                                    Displaying <strong [innerText]="getDisplayCount()"></strong> of
                                    <strong [innerText]="total"></strong>&nbsp;results
                                </p>
                            } @else {
                                <h2 class="search-results-list-format__summary">
                                    Displaying 1-{{ results.length }} of {{ total }} results
                                </h2>
                            }
                        }
                    </div>
                    @if (!isListFormat) {
                        <div
                            (scrolled)="onScroll()"
                            [infiniteScrollDistance]="distance"
                            [infiniteScrollThrottle]="throttle"
                            class="g-4 row row-cols-1 row-cols-sm-2 row-cols-md-3"
                            infinite-scroll>
                            @for (card of results; track trackByFn($index, card)) {
                                <div class="col">
                                    <core-client-block-card
                                        [cardType]="card.type ?? ''"
                                        [card]="card"
                                        [displayTags]="true"
                                        [parentUrl]="parentUrl(card)"
                                        [zone]="currentZone"></core-client-block-card>
                                </div>
                            }

                            @if (isLoading) {
                                @for (shimmer of getShimmerCards(); track shimmer) {
                                    <div class="col">
                                        <core-block-card-shimmer></core-block-card-shimmer>
                                    </div>
                                }
                            }
                        </div>
                    } @else {
                        <div
                            (scrolled)="onScroll()"
                            [infiniteScrollDistance]="distance"
                            [infiniteScrollThrottle]="throttle"
                            class="search-results-list-format"
                            infinite-scroll>
                            @for (card of results; track trackByFn($index, card)) {
                                <div class="search-results-list-format__item">
                                    @if (!card.isDownload) {
                                        <a
                                            [routerLink]="parentUrl(card) + '/' + card.url"
                                            class="search-results-list-format__link">
                                            <div class="search-results-list-format__header">
                                                <h3
                                                    class="search-results-list-format__title"
                                                    [innerHTML]="card.name"></h3>
                                                <span class="material-symbols-outlined search-results-list-format__icon"
                                                    >arrow_forward</span
                                                >
                                            </div>
                                            @if (card.description) {
                                                <p
                                                    class="search-results-list-format__description"
                                                    [innerHTML]="card.description | limitTo: 250"></p>
                                            }
                                        </a>
                                    } @else {
                                        <a
                                            (click)="downloadItem(card.token)"
                                            class="search-results-list-format__link"
                                            href="javascript:void(0)">
                                            <div class="search-results-list-format__header">
                                                <h3
                                                    class="search-results-list-format__title"
                                                    [innerHTML]="card.name"></h3>
                                                <span class="material-symbols-outlined search-results-list-format__icon"
                                                    >download</span
                                                >
                                            </div>
                                            @if (card.description) {
                                                <p
                                                    class="search-results-list-format__description"
                                                    [innerHTML]="card.description | limitTo: 250"></p>
                                            }
                                        </a>
                                    }
                                </div>
                            }

                            @if (isLoading) {
                                @for (shimmer of getShimmerCards(); track shimmer) {
                                    <div class="search-results-list-format__shimmer">
                                        <div class="shimmer-title"></div>
                                        <div class="shimmer-description"></div>
                                    </div>
                                }
                            }
                        </div>
                    }

                    @if (hasMoreContent()) {
                        <button
                            (click)="loadMore()"
                            [innerText]="loadMoreText"
                            class="btn btn-secondary d-block mx-auto mt-3"></button>
                    }
                }
            </div>
        </div>
    </div>
}
